<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box">
          <div class="box-header">
              <label for="recordPerPage" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
              <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                <select v-on:change="changePageSize" ref="recordPerPage" class="form-control">
                  <option v-if="inquiryParam.pageSize == 5" selected>5</option><option v-else>5</option>
                  <option v-if="inquiryParam.pageSize == 10" selected>10</option><option v-else>10</option>
                  <option v-if="inquiryParam.pageSize == 20" selected>20</option><option v-else>20</option>
                  <option v-if="inquiryParam.pageSize == 50" selected>50</option><option v-else>50</option>
                  <option v-if="inquiryParam.pageSize == 100" selected>100</option><option v-else>100</option>
                </select>
              </div>          
              <div class="box-tools">
                <button v-on:click="onCreate" class="btn btn-primary">Create</button>
                <button v-on:click="inquiry" class="btn btn-warning">Search</button>                
              </div>
          </div>        
          <div class="box-body no-padding table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th style="width: 45px;text-align:right;">#</th>
                  <th style="text-align:center;">Action</th>
                  <th style="text-align:left;">Name</th>
                  <th style="text-align:center;">Valid From</th>                    
                  <th style="text-align:center;">Check Quota</th>
                  <th style="text-align:right;">Occupancy</th>
                  <th style="text-align:right;">Max Time Booking</th>
                  <th style="text-align:right;">Is Booking Only</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, i) in listData" v-bind:key="i">
                  <td style="width:45px;text-align:right;">{{ startSequence + i + 1}}</td>
                  <td style="width:85px;text-align:center;">
                    <a href="#" v-on:click="onDisplay(row)" ref="displayRow" style="padding-right:5px">
                      <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                    </a>
                    <a href="#" v-on:click="onEdit(row)" ref="editRow" style="padding-right:5px">
                      <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                    </a>                    
                  </td>
                  <td style="text-align:left;" nowrap>{{ row.name }}</td>
                  <td style="text-align:center;" nowrap>{{ row.valid_from }}</td>
                  <td style="text-align:center;"><input type="checkbox" :checked= row.is_check_quota></td>
                  <td style="text-align:right;" nowrap>{{ row.occupancy }}</td>
                  <td style="text-align:right;">{{ row.max_time }}</td>
                  <td style="text-align:center;"><input type="checkbox" :checked= row.is_booking_only></td>
                  <td hidden>{{ row.id }}</td>
                  <td hidden>{{ row.project_id }}</td>
                  <td hidden>{{ row.category_id }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="box-footer">
            <div class="form-group">
              <label style="width:25px;text-align:right;">
                  <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
              </label>
              <label style="width:35px;text-align:center;">
                  <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
              </label>
              <label>
                  Page
              </label>
              <label>
                  <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
              </label>
              <label id="TotalPageText">
                {{ totalPages }}                
              </label>
              <label style="width:35px;text-align:center;">
                  <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
              </label>
              <label style="width:25px;text-align:left;">
                  <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
// import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'

const MODE_VIEW = 'read'
const MODE_CREATE = 'create'
const MODE_UPDATE = 'update'

export default {
  name: 'Court',
  components: {
    datepicker
  },
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      listData: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'ASC',
        SortExpression: 'name'
      },
      tabActive: '',
      showValidFrom: false
    }
  },
  computed: {
  },
  created() {
    this.inquiry()
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize
    // this.$root.$on('inquiryGateByProject', (projectIds) => {
    //   this.projectIds = projectIds
    //   return this.inquiry()
    // })
  },
  methods: {
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    onSearch(evt) {
      var keyWords = evt.target.value
      var whereClause = ['id', 'like', '\'%' + keyWords + '%\'']
      this.inquiryParam.WhereClause = whereClause.join(' ')
      this.inquiry()
    },
    inquiry() {
      this.inquiryParam.WhereClauseByProject = ''
      if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
        this.inquiryParam.WhereClauseByProject = 'project_id IN (' + this.$store.state.userInfo.projects.join() + ')'
        this.inquiryParam.WhereClauseByProject = this.inquiryParam.WhereClause === '' ? this.inquiryParam.WhereClauseByProject : this.inquiryParam.WhereClauseByProject + ' AND '
      }

      api
        .request('Reservation', 'get', '/api/Reservation/Court?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClause +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          var data = response.data
          this.listData = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages
          this.$refs.recordPerPage.value = this.inquiryParam.PageSize
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onCreate() {
      let params = {
        id: '',
        mode: MODE_CREATE,
        callback: this.$route.name
      }
      this.$router.push({ name: 'CourtForm', params: params })
    },
    onDisplay(row) {
      let params = {
        id: row.id,
        mode: MODE_VIEW,
        callback: this.$route.name
      }
      this.$router.push({ name: 'CourtForm', params: params })
    },
    onEdit(row) {
      let params = {
        id: row.id,
        mode: MODE_UPDATE,
        callback: this.$route.name
      }
      this.$router.push({ name: 'CourtForm', params: params })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// Court.vue?cca73844